<mat-card appearance="outlined">
  <mat-card-content clas="no-title">
    <span class="row">
      <span [innerHtml]="'MAIN_APP_DIALOG.OPEN_DATE.datesAreOpen' | translate"></span>
    </span>
    <span class="row">
      <span [innerHtml]="'MAIN_APP_DIALOG.OPEN_DATE.goToDate' | translate"></span>
    </span>
    <span class="row" style="flex-wrap: wrap; column-gap: 1em; row-gap: 1em;">
      <button *ngFor="let d of dates" mat-raised-button (click)="gotoDate(d)" style="flex: 1">{{printAsDate(d)}}</button>
    </span>
  </mat-card-content>
  <mat-dialog-actions>
    <button mat-stroked-button class="cancel" (click)="close()" [innerText]="'MAIN_APP_DIALOG.close' | translate"></button>
  </mat-dialog-actions>
</mat-card>